import "./blogPostCard.css";

export default function BlogPostCard({
  slug,
  title,
  author,
  date,
  readTime,
  imageUrl,
  tags = [],
}) {
  return (
    <div
      className="blog-post-card"
      onClick={() => (window.location.href = `/read/${slug}`)}
    >
      <h2 className="blog-post-card__title">{title}</h2>
      <div className="blog-post-card__metadata">
        <div>
          <div>{author}</div>
          <div>{date}</div>
          <div>{readTime} mins read</div>
        </div>
      </div>

      <div className="blog-post-card__image">
        <img src={imageUrl} alt={title} />
      </div>

      {tags.length > 0 && (
        <div className="blog-post-card__tags">
          {tags.map((tag, index) => (
            <span key={index} className="blog-post-card__tag">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
